import { alertasPrioritarios } from "@/mocks/dashboard";

const nivelConfig: Record<string, { badge: string; border: string; bg: string }> = {
  critico: {
    badge: "bg-danger-100 text-danger-700",
    border: "border-l-danger-500",
    bg: "bg-danger-50/50",
  },
  alto: {
    badge: "bg-warning-100 text-warning-700",
    border: "border-l-warning-500",
    bg: "bg-warning-50/50",
  },
  medio: {
    badge: "bg-caution-100 text-caution-700",
    border: "border-l-caution-500",
    bg: "bg-caution-50/50",
  },
};

const nivelLabel: Record<string, string> = {
  critico: "Crítico",
  alto: "Alto",
  medio: "Médio",
};

export default function AlertasPrioritarios() {
  return (
    <div className="bg-white rounded-card border border-background-200 p-5">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-lg bg-danger-100 flex items-center justify-center">
          <i className="ri-error-warning-line text-danger-600 text-sm"></i>
        </div>
        <h3 className="text-sm font-semibold text-foreground-900 font-heading">Alertas Prioritários</h3>
      </div>
      <div className="space-y-3">
        {alertasPrioritarios.map((alerta) => {
          const config = nivelConfig[alerta.nivel];
          return (
            <div
              key={alerta.id}
              className={`border-l-2 rounded-r-lg p-3 ${config.border} ${config.bg} cursor-pointer hover:shadow-sm transition-shadow`}
            >
              <div className="flex items-start gap-2.5">
                <div className="w-7 h-7 rounded-full bg-white border border-background-200 flex items-center justify-center shrink-0 mt-0.5">
                  <i className={`${alerta.icone} text-foreground-600 text-xs`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h4 className="text-sm font-medium text-foreground-900">{alerta.titulo}</h4>
                    <span className={`badge ${config.badge}`}>{nivelLabel[alerta.nivel]}</span>
                  </div>
                  <p className="text-xs text-foreground-600 mt-1">{alerta.descricao}</p>
                  <p className="text-xs font-semibold text-foreground-900 mt-1.5">
                    {alerta.quantidade} {alerta.quantidade === 1 ? "ocorrência" : "ocorrências"}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}